module.exports = __webpack_public_path__ + "static/AMA20 Finalist Medal_Brokerage of the Year - Diversification-97975000bd463d786038174f01095db7.png";